/**
 * B2BShell — shared chrome for /admin/* and /firm/* pages.  Simple
 * header with brand, current user email, and a sign-out button.
 */

import { Link, Outlet, useNavigate } from "react-router-dom";
import { useSupaAuth } from "@/context/SupaAuthContext";
import { Buildings, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function B2BShell() {
  const { user, logout } = useSupaAuth();
  const navigate = useNavigate();

  const onSignOut = async () => {
    await logout();
    navigate("/b2b/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F5F1E8]" data-testid="b2b-shell">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/firm" className="flex items-center gap-2 no-underline">
            <Buildings size={22} weight="duotone" className="text-[#2C4C3B]" />
            <span className="font-semibold text-[#2C4C3B]">MedEasy Console</span>
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <span className="text-slate-500 hidden sm:inline" data-testid="b2b-user-email">
              {user?.email}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={onSignOut}
              data-testid="b2b-sign-out"
              className="text-slate-600"
            >
              <SignOut size={16} className="mr-1" />
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
